module.exports = __webpack_public_path__ + "img/antes_despues_79.1efa42a2.png";